// extracted by mini-css-extract-plugin
module.exports = {"zoomControlls":"styles_zoomControlls__3flsv","zoomOutIcon":"styles_zoomOutIcon__3c9F1","zoomInIcon":"styles_zoomInIcon__taIQD","percentage":"styles_percentage__21L6m"};